export const faqSectionData = {
  title: 'Frequently Asked Questions',
  faqs: [
    {
      question: 'How can I list my event on Greet?',
      answer:
        'Listing your event on Greet is easy! Simply click on "Create Event," and follow the prompts to provide details about your event, including date, venue, and ticket types or just call us on 8310516103 and let us do all the work for you :)',
    },
    {
      question:
        'Why is Greet the best choice for your event ticketing platform ?',
      answer:
        'What sets Greet apart from Event Organizers is our commitment to your success. With Greet, you’ll have a dedicated relationship manager by your side, ensuring every aspect of your event is meticulously handled. From pre-event preparations to on-site management, our dedicated manager brings unparalleled dedication to make your event an undeniable success. Experience the difference with Greet’s personalized support for organizers.',
    },
    {
      question: 'What are the benefits of using Greet for our events?',
      answer:
        'Greet has a range of features beyond ticket booking, including event promotion tools, real-time analytics, on-site management, customizable ticket options, secure payments, and 24/7 customer support. Explore the full list in the Features section for a complete overview.',
    },
    {
      question: 'Can I customize ticket types and pricing for my event?',
      answer:
        'Yes, Greet provides organizers with the flexibility to create custom ticket types and set pricing based on their event’s requirements. You can easily manage this through the Organizer Dashboard.',
    },
    {
      question: 'How do I receive payments for ticket sales?',
      answer:
        'Payments for ticket sales are securely processed through Greet, and the funds are transferred to your designated account. As stated you can get your settlements whenever you demand, instantly.',
    },
    {
      question: 'Can I track attendee information and sales analytics?',
      answer:
        'Absolutely! Greet provides robust analytics tools on the Organizer Dashboard, allowing you to track ticket sales, attendee demographics, and other valuable insights to enhance your event planning.',
    },
    {
      question:
        'How can I connect with Greet’s customer support for assistance?',
      answer:
        'Greet offers 24/7 customer support for event organizers. You can reach out through the Organizer Dashboard, and our dedicated support team will promptly assist you with any inquiries or issues.',
    },
    {
      question: 'Is Greet available for international events outside of India?',
      answer:
        'Yes, Greet is actively expanding its reach to other countries. If you’re planning an international event, contact our support team to explore the possibilities and discuss how Greet can support your event’s success.',
    },
  ],
};
